var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 4.78125L7.875 7.78125C8.09375 8.28125 7.96875 8.875 7.53125 9.21875L6 10.5C7.03125 12.6875 8.8125 14.4688 11 15.5L12.2812 13.9688C12.625 13.5312 13.2188 13.4062 13.7188 13.625L16.7188 14.875C17.3125 15.0938 17.5938 15.75 17.4375 16.3438L16.6875 19.0938C16.5312 19.625 16.0625 20 15.5 20C7.75 20 1.5 13.75 1.5 6C1.5 5.4375 1.875 4.96875 2.40625 4.8125L5.15625 4.0625C5.75 3.90625 6.40625 4.1875 6.625 4.78125Z",
    fill: "#6A48B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3b7a3ad3ad73a704903ca8819970e53f.svg";
export { ForwardRef as ReactComponent };